import { equifaxConfig } from 'app/configs';

export const getCreditScoreType = (score: number,isNewCreditPolicy: boolean): string => {
  const credit = equifaxConfig.credit(isNewCreditPolicy);
  if (score > credit.MAX) {
    return null;
  }

  if (score >= credit.A) {
    // Excellent
    return 'A';
  }
  if (score >= credit.B) {
    // Very Good
    return 'B';
  }
  if (score >= credit.C) {
    // Good
    return 'C';
  }
  if (score >= credit.MIN) {
    // Fair
    return 'D';
  }

  return null;
};

export const getCreditFee = (equipTotal: number, leadType: string, creditType: string): number => {
  let creditFee = 0;
  if (leadType === 'Self Gen' || leadType === 'Authorized Partner Security') {
    switch (creditType) {
      case 'B':
        creditFee = equipTotal < 350 ? 199 : 0;
        break;
      case 'C':
        creditFee = equipTotal < 450 ? 299 : 0;
        break;
      default:
        creditFee = 0;
        break;
    }
  }
  return creditFee;
};
